<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-0 lg:py-0 px-6 flex align-items-center justify-content-between lg:static">
            <div class="flex align-items-center">

                <a v-ripple class="cursor-pointer block lg:hidden text-700 mr-5 p-ripple"
                   v-styleclass="{ selector: '#navbar-8', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>

            </div>
        </div>

        <div id="navbar-8"
             class="py-0 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processOverview" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Overview</span>
                    </a>
                </li>
                <li>
                    <a @click="processPassword" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Password</span>
                    </a>
                </li>
                <li>
                    <a @click="processAccountManagement" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Account Management</span>
                    </a>
                </li>
                <li>
                    <a @click="processTerms" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Terms of Use</span>
                    </a>
                </li>
                <li>
                    <a @click="processPrivacy" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Privacy Policy</span>
                    </a>
                </li>
            </ul>
        </div>

    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted: async function() {
        try {
            const pingData = await UserService.getUserPing();
            console.log("[Applications][mounted] System is active.");
            console.log("[Applications][mounted] Data = ", pingData);
        } catch (e) {
            console.log("[Applications][mounted] System is NOT active.");
            console.log("[Applications][mounted] Error = ", e);

            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (this.userStore.user === undefined) {
            console.log("[Applications][mounted] User is NOT defined.");

            this.userStore.clearUser();
            this.$router.push('login');
        } else {
            console.log("[Applications][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
                console.log("[Applications][mounted] Data = ", userData);
            } catch (e) {
                console.log("[Applications][mounted] No user data found.");
                console.log("[Applications][mounted] Error = ", e);

                this.userStore.clearUser();
                this.$router.push('login');
            }
        }
    },
    data() {
        return {
            profile: {},
        }
    },
    methods: {
        processOverview() {
            console.log("[MenuClients][processOverview] Beginning.");
            window.location.href = "/#/commonProfile";
        },
        processPassword() {
            console.log("[MenuClients][processPassword] Beginning.");
            window.location.href = "/#/commonProfilePassword";
        },
        processAccountManagement() {
            console.log("[MenuClients][processAccountManagement] Beginning.");
            window.location.href = "/#/commonProfileAccount";
        },
        processTerms() {
            console.log("[SiFooter][processTerms] Beginning.");
            window.open("https://www.simplyinvesting.com/terms", '_blank');
        },
        processPrivacy() {
            console.log("[SiFooter][processPrivacy] Beginning.");
            window.open("https://www.simplyinvesting.com/privacy", '_blank');
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
